import { render } from "./StorefrontFilterResults.vue?vue&type=template&id=2a55e652"
import script from "./StorefrontFilterResults.vue?vue&type=script&lang=js"
export * from "./StorefrontFilterResults.vue?vue&type=script&lang=js"

import "./StorefrontFilterResults.vue?vue&type=style&index=0&id=2a55e652&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__